<template>
  <div v-if="isEmbedded" class="app-bar-nav">
    <surface-builder />
    <surface-embed-actions />
  </div>
  <div v-else class="app-bar-nav surface-nav">
    <a href="/?ref=logo" class="logo" target="_top" role="button" v-t:title="'Take me home'"
      ><div class="logo-image"
    /></a>
    <menu v-if="showMenuActions" class="app-bar-menu">
      <li v-if="!userRegistered" class="globalnav-signup">
        <a role="button" href="/auth/signup" class="app-bar-button" v-t>Sign up</a>
      </li>
      <li v-if="!userRegistered" class="globalnav-login">
        <a role="button" href="/auth/login" class="app-bar-button" v-t>Log in</a>
      </li>
      <li v-if="userRegistered">
        <button v-if="!isLiked" class="app-bar-button" @click="like" v-t:title="'Like'">
          <base-icon name="favorite_border" />
        </button>
        <button v-else class="app-bar-button" @click="unlike" v-t:title="'Unlike'">
          <base-icon class="highlighted-type" name="favorite" />
        </button>
      </li>
      <li v-if="canRemake">
        <button class="app-bar-button app-bar-icon-text-button" @click="showRemakePanelTracked" v-t:title="'Remake'">
          <base-icon name="remake" /><span class="responsive-no-phone-only" v-t>Remake</span>
        </button>
      </li>
      <li>
        <button class="app-bar-button app-bar-icon-text-button" @click="toggleSharePanelTracked" v-t:title="'Share'">
          <base-icon name="share_arrow" /><span class="responsive-no-phone-only" v-t>Share</span>
        </button>
      </li>
      <li v-if="canModify">
        <button class="app-bar-button" @click="toggleSettingsPanelTracked" v-t:title="'Modify'">
          <base-icon name="settings" />
        </button>
      </li>
      <li v-if="!userRegistered" class="globalnav-help">
        <a role="button" class="app-bar-button" href="http://jn.padlet.com" target="_blank" v-t:title="'Get help'">
          <base-icon name="help_outline" />
        </a>
      </li>
      <li class="globalnav-more">
        <button
          id="globalnav-more-menu-button"
          class="app-bar-button"
          aria-haspopup="true"
          :aria-expanded="xToolMenu"
          aria-owns="globalnav-more-menu"
          aria-controls="globalnav-more-menu"
          @click="toggleToolMenuTracked"
          v-t:title="'More'"
        >
          <base-icon name="more_horiz" />
        </button>
        <menu
          v-if="xToolMenu"
          id="globalnav-more-menu"
          class="dropdown dropdown-with-curtain"
          role="group"
          aria-labelledby="globalnav-more-menu-button"
          @click="hideToolMenu"
        >
          <div class="dropdown-content action-list">
            <a v-if="!userRegistered" href="/auth/signup" class="list-item" tabindex="0" v-t:title="'Sign up'">
              <base-icon name="sign_up" /> <span v-t>Sign up</span>
            </a>
            <a v-if="!userRegistered" href="/auth/login" class="list-item" tabindex="0" v-t:title="'Log in'">
              <base-icon name="fingerprint" /> <span v-t>Log in</span>
            </a>
            <div v-if="!userRegistered" class="divider" />
            <div class="list-item" role="button" tabindex="0" @click="showInfoTracked" v-t:title="'About this padlet'">
              <base-icon name="info_outline" /> <span v-t>Info</span>
            </div>
            <a
              class="list-item"
              role="button"
              href="http://jn.padlet.com"
              target="_blank"
              tabindex="0"
              v-t:title="'Get help'"
            >
              <base-icon name="help_outline" /> <span v-t>Help</span>
            </a>
            <div v-if="!isLiked" class="list-item" role="button" tabindex="0" @click="like" v-t:title="'Like'">
              <base-icon name="favorite_border" /> <span v-t>Like</span>
            </div>
            <div v-if="isLiked" class="list-item" role="button" tabindex="0" @click="unlike" v-t:title="'Unlike'">
              <base-icon class="highlighted-type" name="favorite" /> <span v-t>Unlike</span>
            </div>
            <div
              v-if="canRemake"
              class="list-item"
              role="button"
              tabindex="0"
              @click="showRemakePanelTracked"
              v-t:title="'Remake'"
            >
              <base-icon name="remake" /> <span v-t>Remake</span>
            </div>
            <div
              v-if="canGoFullscreen && !isFullscreen"
              class="list-item"
              role="button"
              tabindex="0"
              @click="enterFullscreenTracked"
              v-t:title="'Enter full screen'"
            >
              <base-icon name="fullscreen" /> <span v-t>Enter full screen</span>
            </div>
            <div
              v-if="canGoFullscreen && isFullscreen"
              class="list-item"
              role="button"
              tabindex="0"
              @click="exitFullscreen"
              v-t:title="'Exit full screen'"
            >
              <base-icon name="fullscreen" /> <span v-t>Exit full screen</span>
            </div>
            <div v-if="canModify || canClone" class="divider" />
            <div
              v-if="canInvite"
              class="list-item"
              role="button"
              tabindex="0"
              @click="goToInvite"
              v-t:title="'Invite people'"
            >
              <base-icon name="group_add" /> <span v-t>Invite people</span>
            </div>
            <div class="list-item" role="button" tabindex="0" @click="goToShare" v-t:title="'Share or embed'">
              <base-icon name="share" /> <span v-t>Share or embed</span>
            </div>
            <div class="list-item" role="button" tabindex="0" @click="goToExport" v-t:title="'Export'">
              <base-icon name="export" /> <span v-t>Export</span>
            </div>
            <div class="list-item" role="button" tabindex="0" @click="print" v-t:title="'Print'">
              <base-icon name="print" /> <span v-t>Print</span>
            </div>
            <div v-if="canModify || canClone" class="divider" />
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              @click="toggleSettingsPanelTracked"
              v-t:title="'Modify'"
            >
              <base-icon name="settings" /> <span v-t>Modify</span>
            </div>
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              @click="showConvertLayoutPanelTracked"
              v-t:title="'Change format'"
            >
              <base-icon name="change_format" /> <span v-t>Change format</span>
            </div>
            <div
              v-if="canModify"
              class="list-item"
              role="button"
              @click="showClearAllDialogTracked"
              v-t:title="'Clear all posts'"
            >
              <base-icon name="erase" /> <span v-t>Clear all posts</span>
            </div>
            <div v-if="canModify" class="list-item" role="button" @click="archiveWallTracked" v-t:title="'Archive'">
              <base-icon name="archive" /> <span v-t>Archive</span>
            </div>
            <div v-if="canModify" class="list-item" role="button" @click="showDeleteDialogTracked" v-t:title="'Delete'">
              <base-icon name="delete" /> <span v-t>Delete</span>
            </div>
          </div>
        </menu>
      </li>
      <li v-if="userRegistered" class="globalnav-user-avatar"><app-bar-account :user="user" /></li>
    </menu>
  </div>
</template>

<script>
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { mapState, mapGetters, mapActions } from 'vuex'
import t from 'vuedirectives/t'
import AppBarAccount from 'vuecomponents/app_bar_account'
import BaseIcon from 'vuecomponents/base_icon'
import SurfaceBuilder from 'vuecomponents/surface_builder'
import SurfaceEmbedActions from 'vuecomponents/surface_embed_actions'
import { isFullscreenAvailable } from 'bits/fullscreen'
import { trackEvent } from 'bits/analytics'
import { ShareSubpanel } from 'vuexstore/modules/share'

export default {
  components: {
    BaseIcon,
    SurfaceBuilder,
    SurfaceEmbedActions,
    AppBarAccount,
  },
  directives: { t },
  computed: {
    ...mapState(['isEmbedded', 'user', 'panel', 'isReadOnly', 'xToolMenu', 'isLikedByCurrentUser']),
    ...mapGetters('browser', ['isFullscreen']),
    ...mapGetters(['canIAdminister', 'canIRemake', 'links', 'canICreateWall']),
    userRegistered() {
      return !!this.user.registered_at
    },
    canModify() {
      return this.canIAdminister
    },
    canClone() {
      return this.canIAdminister
    },
    canRemake() {
      return this.canIAdminister || this.canIRemake
    },
    canInvite() {
      return this.canIAdminister
    },
    isLiked() {
      return this.isLikedByCurrentUser
    },
    canGoFullscreen() {
      return isFullscreenAvailable
    },
    printLink() {
      return this.links.print
    },
    showMenuActions() {
      return !this.isReadOnly
    },
  },
  methods: {
    ...mapActions([
      'showInfo',
      'likeWall',
      'unlikeWall',
      'archiveWall',
      'toggleToolMenu',
      'showRemakePanel',
      'showConvertLayoutPanel',
      'showDeleteDialog',
      'showClearAllDialog',
      'hideToolMenu',
      'showWallQuotaExceeded',
    ]),
    ...mapActions('browser', ['enterFullscreen', 'exitFullscreen']),
    ...mapActions('share', ['toggleSharePanel']),
    ...mapActions('settings', ['toggleSettingsPanel']),
    like() {
      trackEvent('Surface', 'Nav Clicked', 'Like')
      this.likeWall()
    },
    unlike() {
      trackEvent('Surface', 'Nav Clicked', 'Unlike')
      this.unlikeWall()
    },
    goToInvite() {
      this.toggleSharePanel(ShareSubpanel.Members)
    },
    goToShare() {
      return this.goToExport()
    },
    goToExport() {
      this.toggleSharePanel(ShareSubpanel.Main)
    },
    print() {
      trackEvent('Surface', 'Nav Clicked', 'Print')
      window.open(this.printLink)
    },
    enterFullscreenTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Fullscreen')
      this.enterFullscreen()
    },
    toggleSettingsPanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Settings')
      this.toggleSettingsPanel()
    },
    toggleSharePanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Share')
      this.toggleSharePanel(ShareSubpanel.Main)
    },
    showRemakePanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Remake')
      if (this.canICreateWall) {
        this.showRemakePanel()
      } else {
        this.showWallQuotaExceeded()
      }
    },
    toggleToolMenuTracked() {
      trackEvent('Surface', 'Nav Clicked', 'More')
      this.toggleToolMenu()
    },
    showConvertLayoutPanelTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Change Layout')
      this.showConvertLayoutPanel()
    },
    showDeleteDialogTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Delete')
      this.showDeleteDialog()
    },
    showClearAllDialogTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Clear')
      this.showClearAllDialog()
    },
    showInfoTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Info')
      this.showInfo()
    },
    archiveWallTracked() {
      trackEvent('Surface', 'Nav Clicked', 'Archive')
      this.archiveWall()
    },
  },
}
</script>
<style lang="scss" scoped>
@import '~styles/3/modules/all';

.app-bar-menu {
  display: flex;
  align-items: center;

  & > li {
    list-style-type: none;
  }
}

.app-bar-button {
  background: none;
  border: none;
  padding: 0 8px;
  color: inherit;
  font-size: 11px;
  font-weight: 500;
  text-transform: uppercase;
  line-height: 32px;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  color: $caption-text-color;
  color: var(--caption-text-color);

  @include hover {
    color: $body-text-color;
    color: var(--body-text-color);
  }
}
</style>
